<template>
  <div class="detail">
    <b-container>
      <booking-engine size="sm" />
    </b-container>
    <b-container>
      <validation-observer v-slot="{ invalid }">
        <div v-if="!loading">
          <b-row>
            <b-col>
              <dates-title :flight_offer="flight_offer" />
            </b-col>
          </b-row>
        </div>
        <loader v-else class="mt-4" :show_timing_slot="true" />
        <b-row>
          <b-col sm="12" md="7" lg="8" xl="9">
            <div v-if="!loading">
              <div
                v-for="(flight_offer, index) in flight_offers_pricing.flightOffers"
                v-bind:key="'offer_' + index"
              >
                <flight-pad :flight_offer="flight_offer" />
              </div>

              <!-- bagaglio a mano -->
              <personal-bags-info
                v-if="get_config('guiSettings.customizations.showCabinBagsNotes', false)"
                :flight_offer="flight_offers_pricing.flightOffers[0]"
              />
            </div>
            <!-- Branded Fare Upsell: importante render_slider! nasconde lo slider delle branded, reinizializza slick se/qando serve ed evita l'unmount del componente e le conseguenti chiamate indesiderate a get_flight_offers_upsell() -->
            <branded-fare-upsell
              v-if="enable_branded_upsell"
              :render_slider="!loading"
              :render_table="!loading"
              :flight_offer="
                (flight_offers_pricing.flightOffers || []).length > 0
                  ? flight_offers_pricing.flightOffers[0]
                  : flight_offer
              "
            />
            <div v-if="!loading">
              <!-- flex bags -->
              <additional-bags-panel
                v-if="bags && !get_config('guiSettings.customizations.showExtraBagsTable', false)"
                :flexible_bags="flexible_bags"
                :flexible_bags_update_key="flexible_bags_update_key"
                :bags="bags"
                :traveler_details="traveler_details"
                :flight_offer="flight_offer"
                :handle_add_flexible_bag_to_flight_offer="handle_add_flexible_bag_to_flight_offer"
                :flexible_bags_updated="flexible_bags_updated"
              />
              <additional-bags-table
                v-if="bags && get_config('guiSettings.customizations.showExtraBagsTable', false)"
                :flexible_bags="flexible_bags"
                :flexible_bags_update_key="flexible_bags_update_key"
                :bags="bags"
                :traveler_details="traveler_details"
                :flight_offer="flight_offer"
                :handle_add_flexible_bag_to_flight_offer="handle_add_flexible_bag_to_flight_offer"
                :flexible_bags_updated="flexible_bags_updated"
              />

              <!-- sidebar resume -->
              <div v-if="is_mobile()" class="detail--panel side">
                <sidebar-resume :flight_offers="flight_offers_pricing.flightOffers" />
              </div>

              <!-- dett. viaggiatori -->
              <div class="detail--panel traveler-details" compact>
                <div class="d-flex flex-column gap-10px">
                  <!--mb-0-->
                  <div class="d-flex gap-10px">
                    <span v-html="svg_travelers()"></span>
                    <span class="h4 bold m-0"> Dettagli dei Viaggiatori </span>
                  </div>
                  <p class="h6">
                    Inserisci i dati esattamente come compaiono sul documento di identità o sul
                    passaporto. Così eviterai problemi al check-in!
                  </p>
                </div>
                <!-- traveler details -->
                <b-row class="mb-5">
                  <travelers-details-form
                    :contact_details="contact_details"
                    :flight_offer="flight_offer"
                    :traveler_details="traveler_details"
                    :booking_requirements="flight_offers_pricing.booking_requirements || {}"
                  />
                </b-row>

                <b-row>
                  <b-col>
                    <div class="d-flex">
                      <b-form-checkbox v-model="disclaimer_destination_requirements" />
                      <label for="checkbox-disclaimer" class="checkbox-label ml-1">
                        Ho verificato autonomamente le condizioni legali, doganali e sanitarie di
                        accesso nella località o nel Paese di destinazione e sono a conoscenza della
                        documentazione necessaria (ho consultato il sito
                        <a href="https://www.viaggiaresicuri.it/home" target="_blank"
                          >Viaggiare sicuri</a
                        >
                        e quelli delle autorità preposte)
                      </label>
                    </div>
                  </b-col>
                </b-row>

                <b-row>
                  <b-col>
                    <div class="d-flex">
                      <b-form-checkbox v-model="disclaimer_travellers_names" />
                      <label for="checkbox-disclaimer" class="checkbox-label ml-1">
                        Ho verificato che i dati dei viaggiatori corrispondono a quelli riportati
                        nei documenti che verranno utilizzati per l'imbarco e che Nome, Cognome e
                        Data di nascita sono stati inseriti negli appositi campi escludendo anche
                        eventuali inversioni.
                      </label>
                    </div>
                  </b-col>
                </b-row>
              </div>

              <!-- disclaimer / checkout -->
              <div v-if="config.integration.welfare" class="detail--panel mt-4" compact noborder>
                <b-row>
                  <b-col>
                    <div class="d-flex">
                      <b-form-checkbox v-model="disclaimer" />
                      <label for="checkbox-disclaimer" class="checkbox-label ml-1">
                        In qualità di Beneficiario della prestazione (Passeggero 1) dichiaro di aver
                        letto e di accettare l'<a :href="config.site.urlPrivacy" target="_blank"
                          >informativa privacy</a
                        >
                        fornendo il consento al trattamento dei dati personali comunicati
                      </label>
                    </div>
                  </b-col>
                </b-row>
              </div>

              <btn-checkout
                class="mt-4 d-flex justify-content-center"
                @handle_data="handle_travel_data()"
                :fullwidth="false"
                :conditions="
                  invalid ||
                  checkout_btn_conditions ||
                  !get_availability(get_markup(flight_offer).mu_price).affordable
                "
                :popover="
                  !get_availability(get_markup(flight_offer).mu_price).affordable
                    ? ''
                    : get_checkout_btn_popover({
                        missing_details: invalid || !accepted_disclaimers,
                        must_update: flexible_bags_update_key !== 0,
                      })
                "
                :copy="'Continua'"
                id="btn-checkout-content"
              />
              <p
                v-if="!get_availability(get_markup(flight_offer).mu_price).affordable"
                v-b-popover.hover.bottom="
                  'Il tuo credito welfare non è sufficiente ad acquistare questa soluzione'
                "
                class="credit-warning text-center text-danger mt-2 mb-1"
              >
                <span v-html="info" class="text-danger" fill-danger />
                Credito insufficiente
              </p>
            </div>
          </b-col>

          <!-- sidebar -->
          <b-col sm="12" md="5" lg="4" xl="3">
            <div v-if="loading">
              <!--<b-spinner />-->
            </div>
            <div v-else class="sidebar sticky-top">
              <div v-if="!is_mobile()" class="detail--panel detail--panel-sidebar pt-0" compact>
                <sidebar-resume :flight_offers="flight_offers_pricing.flightOffers" />
                <btn-checkout
                  @handle_data="handle_travel_data()"
                  :conditions="
                    invalid ||
                    checkout_btn_conditions ||
                    !get_availability(get_markup(flight_offer).mu_price).affordable
                  "
                  :popover="
                    !get_availability(get_markup(flight_offer).mu_price).affordable
                      ? ''
                      : get_checkout_btn_popover({
                          missing_details: invalid || !accepted_disclaimers,
                          must_update: flexible_bags_update_key !== 0,
                        })
                  "
                  id="btn-checkout-sidebar"
                  :copy="'Continua'"
                />
                <p
                  v-if="!get_availability(get_markup(flight_offer).mu_price).affordable"
                  v-b-popover.hover.bottom="
                    'Il tuo credito welfare non è sufficiente ad acquistare questa soluzione'
                  "
                  class="credit-warning text-center text-danger mt-2 mb-1"
                >
                  <span v-html="info" class="text-danger" fill-danger />
                  Credito insufficiente
                </p>
              </div>
            </div>
          </b-col>
        </b-row>
      </validation-observer>
    </b-container>
  </div>
</template>

<script>
import Vue from 'vue';
import { number } from 'mathjs';
import { get_flight_offers_price } from '@/api';
import {
  reverse_date,
  parse_flight_offers_date,
  is_mobile,
  get_availability,
  parse_flight_offer_for_ecommerce_item,
  custom_event,
  formatPassengerName,
  get_config,
} from '@/utilities';
import {
  get_flight_order_body,
  get_markup,
  add_flexible_bag_to_flight_offer,
  apply_markup_to_number,
  get_flight_offer_dates,
  get_traveler_birth_range_dates,
  set_infant_associated_adult_id,
} from '@/flight-offer';
import { chevron_down } from '@/components/svg/chevrons';
import { info } from '@/components/svg/common';
import { calendar } from '@/components/svg/flight';
import { fakePassenger } from '@/resources/faker';
import { travelers } from '@/components/svg/user';
import { build_store_key, get_stored_value } from '@/utilities/persistent-inputs';

import BookingEngine from '@/components/blocks/booking-engine';
import SidebarResume from '@/components/blocks/sidebar/sidebar-resume';
import FlightPad from '@/components/blocks/flight-pad/flight-pad';
import BrandedFareUpsell from '@/components/blocks/details/branded-fare-upsell';
import BtnCheckout from '@/components/atoms/btn-checkout';
import Loader from '@/components/blocks/loader';
import TravelersDetailsForm from '@/components/blocks/details/travelers-details-form.vue';
import AdditionalBagsPanel from '@/components/blocks/additional-bags/additional-bags-panel.vue';
import AdditionalBagsTable from '@/components/blocks/additional-bags/additional-bags-table.vue';
import PersonalBagsInfo from '@/components/blocks/additional-bags/personal-bags-info.vue';
import DatesTitle from '@/components/blocks/dates-title.vue';

export default {
  name: 'detail',
  components: {
    'booking-engine': BookingEngine,
    'flight-pad': FlightPad,
    'sidebar-resume': SidebarResume,
    'branded-fare-upsell': BrandedFareUpsell,
    'btn-checkout': BtnCheckout,
    loader: Loader,
    'travelers-details-form': TravelersDetailsForm,
    'additional-bags-panel': AdditionalBagsPanel,
    'additional-bags-table': AdditionalBagsTable,
    'personal-bags-info': PersonalBagsInfo,
    'dates-title': DatesTitle,
  },
  props: {},
  data() {
    return {
      loading: true,
      flight_offers_pricing: {},
      default_grand_total: 0,
      config: Vue.prototype.$config,
      //bags: {},//popolato con included.bags, per poter accedere ai bagagli in modo rapido senza passare per la gerarchia traverler->itinerary->flexible_bag
      //flexible_bags: {},
      flexible_bags_update_key: 0, //0 di default, >0 dopo le modifiche (se è maggiore di 0 il pulsante per andare al checkout viene bloccato finché l'utente non prezza i bagagli)
      disclaimer: process.env.VUE_APP_MODE == 'development' ? true : false,
      disclaimer_destination_requirements: process.env.VUE_APP_MODE == 'development' ? true : false,
      disclaimer_travellers_names: process.env.VUE_APP_MODE == 'development' ? true : false,
      enable_branded_upsell:
        Vue.prototype.$config.guiSettings &&
        Vue.prototype.$config.guiSettings.brandedUpsell &&
        Vue.prototype.$config.guiSettings.brandedUpsell.enabled
          ? Vue.prototype.$config.guiSettings.brandedUpsell.enabled
          : false,
      branded_updated: false,
      previous_route_name: '',
      originalInfantHoldingConfiguration: JSON.stringify({}),
      svg_travelers: travelers,
    };
  },
  computed: {
    contact_details: {
      get() {
        if (Object.keys(this.$store.state.liveflight.contact_details).length == 0) {
          let contacts_default = {
            firstname:
              Vue.prototype.$config.integration && Vue.prototype.$config.integration.firstname
                ? Vue.prototype.$config.integration.firstname
                : '',
            middlename: process.env.VUE_APP_MODE == 'development' ? 'Luigi' : '',
            lastname:
              Vue.prototype.$config.integration && Vue.prototype.$config.integration.lastname
                ? Vue.prototype.$config.integration.lastname
                : '',
            second_lastname: process.env.VUE_APP_MODE == 'development' ? 'Verdi' : '',
            email: process.env.VUE_APP_MODE == 'development' ? 'dev@vadobay.com' : '',
            phone: process.env.VUE_APP_MODE == 'development' ? '3936544876' : '',
            country_calling_code:
              this.get_stored_value(
                this.build_store_key(this.$route.name, '1', 'ADULT', 'phone_code')
              ) || '39',
            address: process.env.VUE_APP_MODE == 'development' ? 'via clementina 18' : '',
            zipcode: process.env.VUE_APP_MODE == 'development' ? '60035' : '',
            city: process.env.VUE_APP_MODE == 'development' ? 'Jesi' : '',
            country_code:
              this.get_stored_value(
                this.build_store_key(this.$route.name, '1', 'ADULT', 'country_code')
              ) || 'IT',
          };
          this.$store.commit('contact_details', contacts_default);
        }
        return this.$store.state.liveflight.contact_details;
      },
      set(value) {
        this.$store.commit('contact_details', value);
      },
    },
    traveler_details: {
      get() {
        return this.$store.state.liveflight.traveler_details;
      },
      set(value) {
        this.$store.commit('traveler_details', value);
      },
    },
    flight_offer: {
      get() {
        return this.$store.state.liveflight.flight_offer;
      },
      set(value) {
        this.$store.commit('flight_offer', value);
      },
    },
    dictionaries: {
      get() {
        return this.$store.state.liveflight.results.dictionaries;
      },
      set() {},
    },
    accepted_disclaimers() {
      if (this.config.integration.welfare) {
        // ci sono 2 checkbox/copy specifici per welfare (privacy/disclaimer)
        return (
          this.disclaimer &&
          this.disclaimer_destination_requirements &&
          this.disclaimer_travellers_names
        );
      }
      return this.disclaimer_destination_requirements && this.disclaimer_travellers_names;
    },
    checkout_btn_conditions() {
      return !this.accepted_disclaimers || this.flexible_bags_update_key !== 0;
    },
    bags: {
      get() {
        return this.$store.state.liveflight.bags;
      },
      set(value) {
        this.$store.commit('bags', value);
      },
    },
    flexible_bags: {
      get() {
        return this.$store.state.liveflight.flexible_bags;
      },
      set(value) {
        this.$store.commit('flexible_bags', value);
      },
    },
    has_flexible_bags_last_selection: {
      get() {
        return this.$store.state.liveflight.has_flexible_bags_last_selection;
      },
      set(value) {
        this.$store.commit('has_flexible_bags_last_selection', value);
      },
    },
    departure_date: {
      get() {
        return this.$store.state.liveflight.departure_date;
      },
      set(value) {
        this.$store.commit('departure_date', value);
      },
    },
    heldPassengers() {
      const held = {};
      this.flight_offer.travelerPricings
        .filter((p) => p.travelerType === 'HELD_INFANT')
        .forEach((i) => {
          held[i.travelerId] = i.associatedAdultId;
        });
      return held;
    },
    adults() {
      return this.traveler_details.filter((p) => p.traveler_type === 'ADULT');
    },
  },
  watch: {
    flight_offer: {
      handler(newValue, oldValue) {
        (newValue, oldValue);
        this.loading = true;
        this.$nextTick(() => {
          this.branded_updated = true;
          this.get_detail_data();
        });
      },
      deep: true,
    },
  },
  created() {
    this.number = number;
    this.get_flight_offers_price = get_flight_offers_price;
    this.get_flight_order_body = get_flight_order_body;
    this.get_markup = get_markup;
    this.add_flexible_bag_to_flight_offer = add_flexible_bag_to_flight_offer;
    this.apply_markup_to_number = apply_markup_to_number;
    this.get_flight_offer_dates = get_flight_offer_dates;
    this.chevron_down = chevron_down;
    this.reverse_date = reverse_date;
    this.parse_flight_offers_date = parse_flight_offers_date;
    this.get_traveler_birth_range_dates = get_traveler_birth_range_dates;
    this.info = info;
    this.calendar = calendar;
    this.is_mobile = is_mobile;
    this.get_markup = get_markup;
    this.get_availability = get_availability;
  },
  beforeRouteEnter(to, from, next) {
    next((vm) => {
      vm.previous_route_name = from.name == 'results' ? '' : from.name;
    });
  },
  mounted() {
    this.get_detail_data();
    this.originalInfantHoldingConfiguration = JSON.stringify(this.heldPassengers);
  },
  methods: {
    build_store_key,
    get_stored_value,
    formatPassengerName,
    get_config,
    set_infant_associated_adult_id,
    get_checkout_btn_popover(conditions) {
      if (!conditions) return '';
      if (conditions.missing_details) {
        return 'Per continuare devi accettare le condizioni d’uso e di privacy nonché avere inserito i dettagli di contatto e dei viaggiatori.';
      }
      if (conditions.not_accepted_disclaimers) {
        return 'Prima di continuare, accettare gli appositi disclaimer.';
      }
      if (conditions.must_update) {
        return 'Non hai ancora aggiunto i bagagli extra che hai selezionato. Clicca sul bottone Aggiorna che trovi nella sezione Bagagli in stiva extra.';
      }
      return '';
    },

    get_markup,
    flexible_bags_updated(value, travel_info) {
      // aggiorno la struttura dati per il bagaglio su cui ho cliccato
      const travel_bags = this.flexible_bags[travel_info.traveler_index];
      if (!travel_bags) return;

      const itinerary_bags = travel_bags[travel_info.itinerary_index];
      if (!itinerary_bags) return;

      const bag = itinerary_bags[travel_info.bag_index];
      if (!bag) return;

      this.flexible_bags[travel_info.traveler_index][travel_info.itinerary_index][
        travel_info.bag_index
      ].added = value;

      if (!travel_info.skip_options_cleanup) {
        // caso bookableByItinerary==true con value==false (sto deselezionando un bagaglio) => non fare nient'altro
        // caso bookableByItinerary==true con value==true (sto selezionando un bagaglio) => deseleziono tutti gli altri bagagli per quel passeggero su quell'itinerario
        if (travel_info.bookableByItinerary && value) {
          Object.keys(
            this.flexible_bags[travel_info.traveler_index][travel_info.itinerary_index]
          ).forEach((bag) => {
            if (number(bag) !== travel_info.bag_index)
              this.flexible_bags[travel_info.traveler_index][travel_info.itinerary_index][
                bag
              ].added = false;
          });
        }

        if (!travel_info.bookableByItinerary) {
          // caso bookableByItinerary==false => imposto lo stesso value anche per gli altri itinerari per questo traveler
          Object.keys(this.flexible_bags[travel_info.traveler_index]).forEach((itinerary) => {
            let itinerary_index = number(itinerary);
            this.flexible_bags[travel_info.traveler_index][itinerary_index][
              travel_info.bag_index
            ].added = value;
            // caso bookableByItinerary==false con value==true (sto selezionando un bagaglio) => deseleziono tutti gli altri bagagli per quel passeggero su quell'itinerario
            if (value) {
              Object.keys(
                this.flexible_bags[travel_info.traveler_index][travel_info.itinerary_index]
              ).forEach((bag) => {
                if (number(bag) !== travel_info.bag_index)
                  this.flexible_bags[travel_info.traveler_index][itinerary_index][bag].added =
                    false;
              });
            }
          });
        }

        // deseleziono ( => metto added=false ) eventuali bagagli diversi da quello che sto aggiungendo che siano giù presenti su itinerari diversi dello stesso passeggero
        if (value) {
          Object.keys(this.flexible_bags[travel_info.traveler_index]).forEach((itinerary) => {
            let itinerary_index = number(itinerary);
            if (itinerary_index == travel_info.itinerary_index) return;
            Object.keys(this.flexible_bags[travel_info.traveler_index][itinerary_index]).forEach(
              (bag) => {
                let bag_index = number(bag);
                if (bag_index == travel_info.bag_index) return;
                this.flexible_bags[travel_info.traveler_index][itinerary_index][bag_index].added =
                  false;
              }
            );
          });
        }
      }
      // aggiorno la key per forzare il re-render del tag
      this.flexible_bags_update_key = this.flexible_bags_update_key + 1;
    },
    handle_add_flexible_bag_to_flight_offer(flight_offer, flexible_bags) {
      this.flight_offer = add_flexible_bag_to_flight_offer(flight_offer, flexible_bags);
      this.get_detail_data();
    },
    get_detail_data() {
      this.loading = true;
      this.flexible_bags_update_key = 0;

      //se arrivo dalla ricerca o da un cambio di tariffa, i bagagli nello state sono appena stati resettati (sia bags, sia flexible_bags)
      //se torno indietro dal checkout, voglio mantenere bagagli e selezione che ho già nello state e poterli modificare
      let update_bags = Object.keys(this.flexible_bags).length == 0;

      let params = {
        priceFlightOffersBody: {
          data: {
            type: 'flight-offers-pricing',
            flightOffers: [this.flight_offer],
          },
        },
      };

      if (update_bags) params.include = ['bags'];

      this.get_flight_offers_price(params).then(
        (response) => {
          this.flight_offers_pricing = response.data.data;
          this.default_grand_total = response.data.data.flightOffers[0].price.grandTotal;
          // contact_details e traveler_details nello store vengono azzerati (come per i bagagli) quando seleziono una flight offer (vedi select_flight_offer() dentro flight-pad.vue) => INDEROGABILE, altrimenti creiamo problemi
          // se li trovo popolati nello state, vuol dire che sto tornando indietro con history back o che sto facendo una navigazione diretta a /detail utilizzando l'ultima flight offer che ho selezionato in precedenza
          // se contact_details e traveler_details sono popolati nello state, di conseguenza, fanno fede così come li trovo (in modo che l'utente possa modificarli senza riscriverli)
          if (Object.keys(this.$store.state.liveflight.contact_details).length == 0) {
            response.data.data.flightOffers[0].travelerPricings.forEach((traveler, index) => {
              (traveler, index);

              let birth =
                process.env.VUE_APP_MODE == 'development'
                  ? get_traveler_birth_range_dates(
                      response.data.data.flightOffers[0],
                      traveler.travelerId
                    ).max
                  : '';

              this.traveler_details.push({
                show_datepicker: false,
                traveler_type: traveler.travelerType,
                id: traveler.travelerId,
                ...(process.env.VUE_APP_MODE == 'development'
                  ? {
                      ...fakePassenger(index, [...this.traveler_details.map((t) => t.firstname)]),
                    }
                  : {
                      firstname: '',
                      middlename: '',
                      lastname: '',
                      second_lastname: '',
                      gender:
                        this.get_stored_value(
                          this.build_store_key(
                            this.$route.name,
                            traveler.travelerId,
                            traveler.travelerType,
                            'gender'
                          )
                        ) || 'MALE', // NB, possono essere: MALE, FEMALE, UNSPECIFIED, UNDISCLOSED
                    }),
                birth: birth,
                //country_code: 'IT',
                //passport: (process.env.VUE_APP_MODE == 'gerryxxx')? '12345678' : '',
                //passport_issue_date: (process.env.VUE_APP_MODE == 'gerryxxx')? '2020-10-26' : '',
                //passport_expiration_date: (process.env.VUE_APP_MODE == 'gerryxxx')? '2030-10-26' : '',
                //email: (process.env.VUE_APP_MODE == 'gerryxxx')? 'dev@salabam.com' : '',
              });
            });
          } else {
            this.traveler_details[0] = {
              ...(this.traveler_details[0] || {}),
              firstname: this.contact_details.firstname,
              lastname: this.contact_details.lastname,
            };
          }

          // gestione warnings bagagli
          let raise_bags_warning = false;

          if (this.flight_offers_pricing.flightOffers[0].price.additionalServices == undefined) {
            raise_bags_warning = true;
          } else if (
            this.flight_offers_pricing.flightOffers[0].price.additionalServices.filter(
              function (s) {
                return s.type == 'CHECKED_BAGS';
              }
            ).length == 0
          ) {
            raise_bags_warning = true;
          }

          let is_detail_route = this.$router.currentRoute.name == 'detail';

          // se ho appena cambiato tariffa mostro solo il warning senza l'errore
          if (this.branded_updated && update_bags) {
            this.branded_updated = false;
            raise_bags_warning = false;
            if (is_detail_route && this.has_flexible_bags_last_selection)
              window.eventBus.$emit('got_toast_notification', {
                text: 'Attenzione! Scegliendo la nuova tariffa i bagagli extra sono stati azzerati. Se desideri, seleziona di nuovo i bagagli extra.',
                variant: 'warning',
              });
            this.has_flexible_bags_last_selection = false;
          }

          if (raise_bags_warning) {
            let has_bags = false;
            // resetto i bagagli selezionati se ce ne sono
            Object.keys(this.flexible_bags).forEach((t) => {
              let traveler = this.flexible_bags[t];
              Object.keys(traveler).forEach((i) => {
                let itinerary = traveler[i];
                Object.keys(itinerary).forEach((b) => {
                  if (itinerary[b].added) has_bags = true;
                  itinerary[b].added = false;
                });
              });
            });
            // lancio la notifica toast solo se ci sono bagagli che non è stato possibile prezzare
            if (has_bags && is_detail_route) {
              window.eventBus.$emit('got_toast_notification', {
                text: 'La combinazione di bagagli che hai scelto non è consentita e NON sono stati aggiunti. Puoi acquistare bagagli anche per un solo passeggero ma se li acquisti a più passeggeri devono essere aggiunti sugli stessi itinerari.',
                variant: 'danger',
              });
            }
          }

          if (!update_bags) {
            this.loading = false;
            return;
          }

          if (response.data.included) {
            this.initialize_checked_flexible_bags(response.data.included.bags);
          }

          custom_event({
            event: 'view_item',
            ecommerce: {
              currency: 'EUR',
              items: [parse_flight_offer_for_ecommerce_item(response.data.data.flightOffers[0])],
              transaction_id: '',
              affiliation: '',
              value: 0, // Sum of (price * quantity) for all items.
              tax: 0,
              shipping: 0,
              coupon: '',
            },
          });

          this.loading = false;
        },
        () => {
          this.loading = false;
        }
      );
    },
    initialize_checked_flexible_bags(data_bags) {
      if (!data_bags) {
        return;
      }
      this.bags = data_bags;
      this.flight_offers_pricing.flightOffers[0].travelerPricings.forEach((t, traveler_index) => {
        let traveler_flexible_bags = {};
        if (t.travelerType == 'HELD_INFANT' || t.travelerType == 'SEATED_INFANT') {
          return;
        }
        this.flight_offers_pricing.flightOffers[0].itineraries.forEach((i, itinerary_index) => {
          const itinerary_bags = {};
          Object.keys(this.bags).forEach((b) => {
            itinerary_bags[b] = {
              bag: this.bags[b],
              added: false,
            };
            // Reconstruct the flexible bags objet
            (t.fareDetailsBySegment || []).forEach((segment_fare) => {
              const { chargeableCheckedBags } = segment_fare.additionalServices || {};
              if (chargeableCheckedBags) {
                const { quantity = 0, weight } = chargeableCheckedBags;
                const bags = Object.entries(itinerary_bags).filter((entry) => {
                  const bag = entry[1].bag || {};
                  return (bag.travelerIds || []).includes(t.travelerId);
                });
                for (let index = 0; index < bags.length; index += 1) {
                  const entry = bags[index];
                  const bag = entry[1].bag;
                  if ((bag.quantity || 1) === quantity && bag.weight === weight) {
                    itinerary_bags[entry[0]].added = true;
                  }
                }
              }
            });
          });
          traveler_flexible_bags[itinerary_index] = itinerary_bags;
        });
        this.flexible_bags[traveler_index] = traveler_flexible_bags;
      });
    },
    toggle_birth_calendar(index) {
      this.traveler_details[index].show_datepicker = !this.traveler_details[index].show_datepicker;
    },
    handle_travel_data() {
      const flightOffers = this.flight_offers_pricing.flightOffers;
      if (this.originalInfantHoldingConfiguration !== JSON.stringify(this.heldPassengers)) {
        flightOffers[0] = this.set_infant_associated_adult_id(flightOffers[0], this.heldPassengers);
      }

      let flight_order_body = this.get_flight_order_body({
        flight_offers_pricing: flightOffers,
        traveler_details: this.traveler_details,
        contact_details: this.contact_details,
      });

      let booking_data = {
        live_price: this.get_markup(flightOffers[0]).mu_price,
        flightCreateOrderBody: flight_order_body,
      };

      this.$store.commit('flight_offer', flightOffers[0]);
      this.$store.commit('booking_data', booking_data);

      // Check feature flag
      if (this.get_config('endpoints.seatmaps', false)) {
        this.$router.push('seat-selection');
      } else {
        this.$router.push('checkout');
      }
    },
  },
};
</script>
<style lang="scss">
.detail {
  .sidebar.sticky-top {
    @include media-breakpoint-up(md) {
      position: sticky;
      top: 20px;
      z-index: 0;
    }
  }

  .dp-toggle {
    position: relative;
    &--handler {
      background: transparent;
      position: absolute;
      left: 0;
      right: 0;
      top: 0;
      bottom: 0;
      z-index: 1;
    }
  }

  &--panel {
    @extend .panel !optional;
    margin-bottom: 1rem !important;

    &--datepicker--birth {
      margin-top: 1rem;
      position: absolute;
      z-index: 2;
    }
  }

  .collapse--title {
    display: flex;
    justify-content: space-between;
    div.icon svg {
      transition: $transition-base;
      transform: rotate(180deg);
    }
    &.not-collapsed {
      margin-bottom: 1rem;
      div.icon svg {
        transform: rotate(0deg);
      }
    }
  }

  .bags {
    overflow: hidden;
    .table {
      thead {
        background-color: #f8f9fa;

        th {
          border-bottom: 0;
          text-align: center;
        }
      }
      tbody {
        border-bottom: 1px solid $gray-300;

        &:before {
          content: '';
          display: block;
          height: 10px;
        }

        & + tbody {
          border: 0;
        }
      }

      td {
        border-width: 0 0 1px;
        border-style: solid;
        border-color: $gray-300;
      }
    }
    &--traveler {
      max-width: 100px;
    }
  }

  .side {
    padding-top: 0;
  }

  // forzatura per avere il background del bagaglio selezionato con il padding corretto
  .detail--bag {
    .row {
      padding: $grid-gutter-width/2 0;
      margin-left: -20px;
      margin-right: -20px;
      //margin-bottom:$grid-gutter-width/2;
    }
    &.selected .row {
      background-color: $light-blue;
    }
    &:not(.selected) .row {
      border-bottom: 1px solid $light-gray;
    }
    .col-12 {
      padding-left: 20px;
      padding-right: 20px;
    }
    &:first-child:not(.selected) .row {
      border-top: 1px solid $light-gray;
    }
    &:last-child .row {
      border-bottom: 0;
      margin-bottom: 0;
    }
  }

  .badge {
    &-baggage {
      display: inline-block;
    }

    &--icon {
      width: 21px;
      margin-right: 3px;
      display: inline-block;
      vertical-align: middle;
    }

    &--text {
      display: none;

      @include media-breakpoint-up(sm) {
        display: inline-block;
        margin-top: 3px;
        padding-right: 5px;
        display: inline-block;
        vertical-align: middle;
        cursor: default;
      }
    }
  }

  .credit-warning {
    font-size: 11px;
    line-height: 1;
  }
}
</style>
